var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"barrageWrapper",staticClass:"barrage-wrapper"},[_c('div',{staticClass:"barrage-main"},[_c('div',{ref:"barrageMainDm",staticClass:"barrage-main-dm",class:{ 'ani-pause': _vm.isPause, 'ani-running': !_vm.isPause }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }